export default __webpack_public_path__ + "static/media/reaper_logo.7ba83506.svg";